module.exports = __webpack_public_path__ + "img/42_35_440_008.f8d7a750.jpg";